import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Link } from "@mui/material";
import HomeSection from "./HomeSection";
import TeamLogoRail from "../playerSearch/TeamLogoRail";
import {
  getActiveNbaFranchises,
  railTeamsFromNbaFranchises,
} from "../../utils/nbaFranchises";

const NbaTeamsRow = () => {
  const navigate = useNavigate();
  const teams = railTeamsFromNbaFranchises(getActiveNbaFranchises());

  return (
    <HomeSection
      title="NBA teams"
      subtitle="Current franchises — tap one to see every player who suited up"
      noPadding
      action={
        <Link
          component={RouterLink}
          to="/app/nba/teams"
          underline="hover"
          color="text.secondary"
          variant="body2"
          fontWeight={600}
        >
          View all teams
        </Link>
      }
    >
      <TeamLogoRail
        teams={teams}
        onSelect={(franchiseId) => navigate(`/app/nba/teams/${franchiseId}`)}
      />
    </HomeSection>
  );
};

export default NbaTeamsRow;
